<style>
.select-paper .summary-wrapper {
	position: absolute;
}
.select-paper .paper-select-ul li {
	background: none;
	color: #666;
}
</style>
<template>
<div class="select-paper">
	<transition name="slide">
		<div v-show="show" class="summary-wrapper">
			<a class="bill-filter-cancel"></a>
			<navbar title="选择证照类型"></navbar>
			<div class="summary-filter-shell">
				<ul class="summary-filter-ul paper-select-ul">
					<li @click="selectPaper('01', '营业执照')">营业执照</li>
					<li @click="selectPaper('02', '税务登记证')">税务登记证</li>
					<li @click="selectPaper('03', '组织机构代码证')">组织机构代码证</li>
					<li @click="selectPaper('04', '卫生许可证')">卫生许可证</li>
					<li @click="selectPaper('05', '生产许可证')">生产许可证</li>
					<li @click="selectPaper('06', '食品经营许可证')">食品经营许可证</li>
					<li @click="selectPaper('07', '检验报告')">检验报告</li>
					<li @click="selectPaper('08', 'ISO认证证书')">ISO认证证书</li>
					<li @click="selectPaper('09', '商标注册证')">商标注册证</li>
					<li @click="selectPaper('10', '健康证')">健康证</li>
					<li @click="selectPaper('11', '其他')">其他</li>
				</ul>
			</div>
		</div>
	</transition>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
</div>
</template>
<script>
import NavBar from '../components/NavBar'
import TipsAuto from '../components/TipsAuto'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			tipsauto: false,
			tipsFont: '',
			sec: 1500,
			show: false,
			startDate: '',
			endDate: '',
			store: GlobalStore
		}
	},
	components: {
		'navbar': NavBar,
		'tips-auto': TipsAuto
	},
	methods: {
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		open (val) {
			this.show = !this.show
		},
		selectPaper (id, name) {
			this.show = false
			var info = {
				id: id,
				name: name
			}
			this.$emit('selectPaper', info)
		}
	}
}
</script>



// WEBPACK FOOTER //
// SelectPaper.vue?0143fdaa